import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Create a New File", -1)
const _hoisted_2 = { class: "form-input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Workspace Location", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "/" }, "/", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-input" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "File Name", -1)
const _hoisted_8 = { class: "modal-footer text-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Add File", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { ref, watchEffect } from 'vue';
import DefaultModal from '@/components/atomic/DefaultModal.vue';
import DefaultIcon from '@/components/atomic/DefaultIcon';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewFileDialog',
  props: {
  show: Boolean,
  workspace: Object
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;


const showTracker = ref(false);

const selNewFileLocation = ref('');
const txtNewFileName = ref('');

const newFileModal = (
  inputEvent: Event,
  fileName: string,
  path: string) => {
  const onlyInParent= false;
  const content= '';
  props.workspace.addEditor(inputEvent, onlyInParent, content, fileName, path);
  closeModal();
};


const getProposedFileName = (): string => {
  let newEditorId = 0;
  const ids = props.workspace.editors.map((v) => {
    return parseInt(v.id)
  });
  if (ids.length) {
    newEditorId = Math.max(...ids) + 1;

  }
  return `Untitled-${newEditorId}`;
};

const initModalFields = () => {
  selNewFileLocation.value = '/';
  txtNewFileName.value = getProposedFileName(props.workspace);
};

const closeModal = () => {
  txtNewFileName.value = '';
  showTracker.value = false;
  emit('close');
};

watchEffect(() => {
  const r = new RegExp('/|\\\\', 'g');
  txtNewFileName.value = txtNewFileName.value.replace(r, '');
  if (props.show && !showTracker.value) {
    showTracker.value = true;
    initModalFields();
  }
});



return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createBlock(DefaultModal, { key: 0 }, {
        header: _withCtx(() => [
          _createElementVNode("h3", null, [
            _createVNode(_unref(DefaultIcon), {
              class: "title-icon",
              icon: "codicon-new-file"
            }),
            _hoisted_1
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selNewFileLocation).value = $event))
            }, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreePaths(), (path) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                  path
                    ? (_openBlock(), _createElementBlock("option", {
                        key: 0,
                        value: path
                      }, _toDisplayString(path), 9, _hoisted_5))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 512), [
              [
                _vModelSelect,
                selNewFileLocation.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((txtNewFileName).value = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (newFileModal($event, txtNewFileName.value, selNewFileLocation.value)), ["enter"])),
              type: "text"
            }, null, 544), [
              [
                _vModelText,
                txtNewFileName.value,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (__props.workspace)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "modal-button modal-button-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (newFileModal($event, txtNewFileName.value, selNewFileLocation.value)))
                }, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "modal-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (closeModal()))
            }, " Close ")
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})